module.exports = __webpack_public_path__ + "static/img/honor2.e2b88ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/honor2.png
// module id = ZbMq
// module chunks = 1